import { del, get, post, put, postForm, postForAudio, putForm, getWithMediaHeader, apiWrapper } from "./api-methods";
import * as url from "./api-urls"

// dashboard
export const getDashboardData = (data) => apiWrapper(get,url.GET_DASHBOARD_DATA, data)

// AGENT
export const createNewAgent = (data) => apiWrapper(postForm,url.CREATE_NEW_AGENT, data)
export const getVoices = (data) => apiWrapper(get,url.GET_VOICES, data)
export const getVoicePreview = (data) => apiWrapper(postForAudio,url.VOICE_PREVIEW, data)
export const getAllAgents = (data) => apiWrapper(get,url.GET_ALL_AGENTS, data)
export const getSingleAgent = (id) => apiWrapper(get,url.GET_SINGLE_AGENT + "/" + id)
export const updateAgent = (data) => apiWrapper(putForm,url.UPDATE_AGENT, data)
export const updateAgentStatus = (data) => apiWrapper(put,url.UPDATE_AGENT_STATUS, data)
export const makeAgentPrimary = (data) => apiWrapper(put,url.MAKE_PRIMARY, data)

// PROMPT
export const getPrompt = (data) => apiWrapper(get,url.GET_PROMPT, data)
export const createPrompt = (data) => apiWrapper(post,url.CREATE_PROMPT, data)
export const updatePrompt = (data, id) => apiWrapper(put,url.UPDATE_PROMPT + "/" + id, data)
export const deletePrompt = (id) => apiWrapper(del,url.DELETE_PROMPT + "/" + id)
export const getPromptTemplate = (type) => apiWrapper(get,url.GET_PROMPT_TEMPLATE, type)
export const getSinglePromptTemplate = (id) => apiWrapper(get,url.GET_PROMPT_TEMPLATE + "/" + id)

// PROMPT QUALITY — see ideas/06-ai-prompt-writer.md
// checkPrompt takes either { promptId } or { prompt, firstMessage }, so the
// editor can check what is on screen before it has been saved.
export const checkPrompt = (data) => apiWrapper(post,url.CHECK_PROMPT, data)
// Sorts a pasted prompt into the editor's sections without rewording it.
export const tidyPrompt = (prompt) => apiWrapper(post,url.TIDY_PROMPT, { prompt })
export const getGuardrails = (industry) => apiWrapper(get,url.GET_GUARDRAILS, industry ? { industry } : {})
export const aiWritePrompt = (data) => apiWrapper(post,url.AI_WRITE_PROMPT, data)
export const getPromptVersions = (id) => apiWrapper(get,url.PROMPT_VERSIONS + "/" + id + "/versions")
export const revertPrompt = (id, versionId) => apiWrapper(post,url.PROMPT_VERSIONS + "/" + id + "/revert", { versionId })
export const aiEditPrompt = (id, instruction) => apiWrapper(post,url.AI_EDIT_PROMPT + "/" + id + "/ai-edit", { instruction })
export const applyPromptEdit = (id, sections, instruction) => apiWrapper(post,url.AI_EDIT_PROMPT + "/" + id + "/apply-edit", { sections, instruction })
export const postCommpanyInfo = (data) => apiWrapper(post,url.POST_COMPANY_INFO, data)
export const generateQuickStart = (data) => apiWrapper(post,url.QUICK_START, data)

// MAKE CALL
export const makeCall = (data) => apiWrapper(post,url.MAKE_CALL, data)
export const sendCallOtp = (data) => apiWrapper(post,url.SEND_CALL_OTP, data)
export const demoCall = (data) => apiWrapper(post,url.DEMO_CALL, data)
export const getCallLogs = (data) => apiWrapper(get,url.CALL_LOGS, data)
export const getTestCallLogs = (data) => apiWrapper(get,url.TEST_CALL_LOGS, data)
export const getCallRecordings = (data) => apiWrapper(getWithMediaHeader,url.CALL_RECORDINGS+data)
export const endCall = (data) => apiWrapper(post,url.END_CALL + "?callSid=" + data)

// CAMPAIGN
export const createNewCampaign = (data) => apiWrapper(post,url.CREATE_NEW_CAMPAIGN, data)
export const createCampaignFiles = (data) => apiWrapper(postForm,url.CREATE_CAMPAIGN_FILES, data)
export const getCampaigns = (data) => apiWrapper(get,url.GET_CAMPAIGNS, data)
export const getSingleCampaign = (data) => apiWrapper(get,url.GET_SINGLE_CAMPAIGN + "/" + data)
export const addNewCampaignData = (data) => apiWrapper(put,url.ADD_NEW_CAMPAIGN_DATA, data)
export const UpdateCampaignInfo = (data) => apiWrapper(put,url.UPDATE_CAMPAIGN_INFO, data)
export const campaignStatus = (data) => apiWrapper(put,url.CAMPAIGN_STATUS, data)
export const paymentProcess = (data) => apiWrapper(post,url.PAYMENT_PROCESS, data)

// Webhook
export const getTags = (data) => apiWrapper(get,url.GET_TAGS, data)

// Configuration
export const getConfiguration = (data) => apiWrapper(get,url.GET_CONFIGURATION, data)
export const postConfiguration = (data) => apiWrapper(post,url.GET_CONFIGURATION, data)
export const getEmailConfiguration = (data) => apiWrapper(get,url.GET_EMAIL_CONFIGURATION, data)
export const putEmailConfiguration = (data) => apiWrapper(put,url.PUT_EMAIL_CONFIGURATION, data)
export const postWebhookConfiguration = (data) => apiWrapper(post,url.POST_WEBHOOK_CONFIGURATION, data)
export const getWebhookConfiguration = (data) => apiWrapper(get,url.GET_WEBHOOK_CONFIGURATION, data)
export const putWebhookConfiguration = (data, id) => apiWrapper(put,url.POST_WEBHOOK_CONFIGURATION + "/" + id, data)
export const delWebhookConfiguration = (id) => apiWrapper(del,url.DELETE_WEBHOOK_CONFIGURATION + "/" + id)

// Payments and Billings
export const getPlans = (data) => apiWrapper(get,url.GET_PLANS, data)
export const getPhoneNumbers = (data) => apiWrapper(get,url.GET_PHONE_NUMBERS, data)
export const getBillingDetails = (data) => apiWrapper(get,url.GET_BILLING_DETAILS, data)
export const cancelSubscription = (data) => apiWrapper(post,url.CANCEL_SUBSCRIPTION + "/" + data)
export const getInvoices = (data) => apiWrapper(get,url.GET_INVOICES, data)
export const addFunds = (data) => apiWrapper(post,url.ADD_FUNDS, data)
export const autoTopup = (data) => apiWrapper(post,url.AUTO_TOPUP, data)
export const getPaymentMethods = (data) => apiWrapper(get,url.GET_PAYMENT_METHODS, data)
export const addCard = (data) => apiWrapper(post,url.ADD_CARD, data)
export const setPrimaryCard = (data) => apiWrapper(post,url.SET_PRIMARY_CARD, data)
export const removeCard = (paymentMethodId) => apiWrapper(del,url.REMOVE_CARD + "/" + paymentMethodId)
export const chooseAnotherCountry = (data) => apiWrapper(post,url.CHOOSE_ANOTHER_CONTRY, data)
export const getCheckUserTrialInfo = (data) => apiWrapper(get,url.TRIAL_DETAILS, data)
export const letsTalkPlan = () => apiWrapper(post,url.LETSTALK)

// USER
export const getUserProfile = (data) => apiWrapper(get,url.GET_USER_PROFILE, data)
export const UpdateTour = (data) => apiWrapper(put,url.UPDATE_TOUR, data)